export default "__VITE_ASSET__BJQmzuXH__"